export const styles = {
  uploadBox: (hasFiles) => `
    border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-all
    ${hasFiles
      ? 'border-green-500 dark:border-green-500 bg-green-50 dark:bg-green-900/10'
      : 'border-gray-300 dark:border-gray-700 hover:border-blue-500 dark:hover:border-blue-500 bg-white dark:bg-gray-800'
    }
  `,
  
  extractionUploadBox: (hasFiles) => `
    border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-all duration-200
    ${hasFiles
      ? 'border-green-400 dark:border-green-500 bg-gradient-to-br from-green-50 to-white dark:from-green-900/10 dark:to-gray-800'
      : 'border-gray-300 dark:border-gray-600 hover:border-purple-400 dark:hover:border-purple-500 bg-gradient-to-br from-gray-50 to-white dark:from-gray-800 dark:to-gray-900'
    }
  `,
  
  modeToggleButton: (isActive, modeType) => `
    flex items-center gap-2 px-6 py-3 rounded-md text-sm font-medium transition-all
    ${isActive
      ? modeType === 'upload'
        ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
        : 'bg-white dark:bg-gray-700 text-purple-600 dark:text-purple-400 shadow-sm'
      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-300'
    }
  `,
  
  disabledModeToggleButton: (modeType) => `
    flex items-center gap-2 px-6 py-3 rounded-md text-sm font-medium transition-all
    text-gray-400 dark:text-gray-500 cursor-not-allowed opacity-50 relative
  `,
  
  fileTypeButton: (isSelected) => `
    px-5 py-2.5 rounded-md text-sm font-medium border transition-all
    ${isSelected
      ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
      : 'border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:border-blue-400 dark:hover:border-blue-500 bg-white dark:bg-gray-800'
    }
  `,
  
  submitButton: (isDisabled) => `
    px-8 py-3 text-sm font-medium rounded-md transition-all w-full max-w-xs
    ${isDisabled
      ? 'bg-gray-200 dark:bg-gray-800 text-gray-400 dark:text-gray-500 cursor-not-allowed'
      : 'bg-green-600 hover:bg-green-700 text-white shadow-md hover:shadow-lg'
    }
  `,
  
  disabledFeatureMessage: `
    mt-4 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 rounded-lg
  `,
  
  disabledStateContainer: `
    bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-8
  `,
  
  disabledIconContainer: (iconType = 'extraction') => `
    inline-flex items-center justify-center w-16 h-16 rounded-full mb-4
    ${iconType === 'extraction'
      ? 'bg-yellow-100 dark:bg-yellow-900/20'
      : 'bg-blue-100 dark:bg-blue-900/20'
    }
  `,
  
  disabledIcon: (iconType = 'extraction') => `
    text-2xl
    ${iconType === 'extraction'
      ? 'text-yellow-500'
      : 'text-blue-500'
    }
  `,
  
  featureListContainer: `
    bg-gray-50 dark:bg-gray-900/30 rounded-lg p-4 max-w-md mx-auto mb-6
  `,
  
  featureListTitle: `
    text-sm font-medium text-gray-700 dark:text-gray-300 mb-2
  `,
  
  featureListItem: `
    text-sm text-gray-600 dark:text-gray-400
  `,
  
  switchButton: (type = 'primary') => `
    px-6 py-3 rounded-md font-medium transition-colors shadow-sm
    ${type === 'primary'
      ? 'bg-blue-600 hover:bg-blue-700 text-white'
      : 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 hover:bg-yellow-200 dark:hover:bg-yellow-900/40 border border-yellow-300 dark:border-yellow-700'
    }
  `,
  
  notificationDot: `
    absolute -top-1 -right-1
  `,
  
  notificationPing: `
    animate-ping absolute inline-flex h-full w-full rounded-full opacity-75
  `,
  
  notificationDotInner: (color = 'yellow') => `
    relative inline-flex rounded-full h-3 w-3
    ${color === 'yellow'
      ? 'bg-yellow-500'
      : 'bg-blue-500'
    }
  `
};